import React, {useEffect, useState} from "react"
import Heading from "../../../../components/dashboard/heading-component/Heading";
import {Col, Form, Row} from "react-bootstrap"
import {GDateIcon, GStarIcon} from "../../../../../assets/icons/cardIcons";
import {Controller, useForm} from "react-hook-form";
import {checkEmptySpaces, maxLength, Required} from "../../../../utils/patterns";
import TextInput from "../../../../components/common/input-field/TextInput";
import DescriptionField from "../../../../components/common/description-field/DescriptionField";
import ThemeButton from "../../../../components/common/theme-button/ThemeButton";
import {useNavigate} from "react-router";
import {notification} from "antd";
import {RoundedCheck} from "../../../../../assets/icons/defaultIcons";
import {useParams} from "react-router-dom";
import {JournalService as GratitudeJournal, JournalService} from "../../../../services/journals-api.service";
import dayjs from "dayjs";
import JournalDetailsSkeleton from "../../../skeletons/journals/journal-pages/JournalDetailsSkeleton";
import {useJournal} from "../../../../providers/JournalContext";

export default function EditDetails() {
    const [data, setData] = useState([]);
    const [loader , setLoader] = useState(true)
    const [questions, setQuestions] = useState([])
    const navigate = useNavigate()
    let { id } = useParams();
    const { validateJournalPass, setValidateJournalPass} = useJournal()
    async function GetJournal(id) {
        setLoader(true)
        const response = await JournalService.getSingleJournal(id);

        const labels = response.data.data.data.result.content.map(item => item.label);
        setQuestions(labels);
        if(response?.data?.data?.status) {
            setData(response?.data?.data?.data.result)

            setLoader(false)
        }
    }
    useEffect(()=>{
        GetJournal(id)
    },[])



    const {
        handleSubmit,
        reset,
        setValue,
        getValues,
        register,
        formState: {errors},
        control,
        clearErrors
    } = useForm({
        mode: 'onChange',
    })


    const onSubmit = async (formData) => {
        setLoader(true)
        // Create the payload using formDataArray
        let payload = {
            questionId: id, // Assuming 'id' is defined somewhere
            content: questions.map(label => ({
                label: label,
                text: formData[`question${questions.indexOf(label)}`]
            }))
        };


        const response = await GratitudeJournal.editJournal(id,payload)

        if (response?.data?.data?.status){
            notification.success({
                message: "Success",
                description: response?.data?.data?.message,
                placement: "topRight",
                icon: <RoundedCheck/>,
                duration: 2,
            });
            setLoader(false)
            navigate(`/journals/details/${id}`)
        }
        // else{
        //     notification.error({
        //         message: "Failed",
        //         description:  response?.data?.data?.message,
        //         placement: "topRight",
        //         icon: <CloseRoundedCheck/>,
        //         duration: 2,
        //     });
        //     setLoader(false)
        // }

    }

    if(validateJournalPass) {
        navigate('/journals/validate-password')
    }

    if (loader){
        return <JournalDetailsSkeleton/>
    }

    return(
        <div className={'journal-details'}>
            <Heading back={true} heading={'Edit Journal'}/>
            {!loader &&
            <Row className={'flex-column-reverse flex-md-row d-flex mt-5'}>
                    <Col md={8}>
                        <Form onSubmit={handleSubmit(onSubmit)}>
                            {  data?.type === 're-frame' &&
                            <Row>
                                {
                                    data?.content.map((item,index)=>{
                                        return(
                                            <Col md={12} key={index}>
                                                <div className={'dfields'}>
                                                    {/* Hidden input field for label */}
                                                    <Controller
                                                        name={`question${index}`}
                                                        defaultValue={item.text}
                                                        control={control}
                                                        rules={{validate: checkEmptySpaces ,required: Required, maxLength: maxLength(10000)}}
                                                        render={({field: {name, ...field}}) => (
                                                            <TextInput
                                                                placeholder={'Enter Title'}
                                                                label={item.label}
                                                                type={'text'}
                                                                field={field}
                                                                errors={errors[`question${index}`]}
                                                                className={'required'}
                                                            />
                                                        )}
                                                    />
                                                </div>
                                            </Col>
                                        )
                                    })
                                }
                            </Row>
                            }
                            { data?.type === 'free-flow' &&
                            <Row>
                                {
                                    data?.content.map((item,index)=>{

                                        return(
                                            <Col md={12} key={index}>
                                                <div className={'dfields'}>
                                                    <Controller
                                                        name={`question${index}`}
                                                        defaultValue={item.text}
                                                        control={control}
                                                        rules={{required:Required, maxLength: maxLength(10000) , validate:checkEmptySpaces}}
                                                        render={({field: {name, ...field}}) => (
                                                            <DescriptionField
                                                                label={'Journal Entry'}
                                                                placeholder={'Write your text here'}
                                                                type={'text'}
                                                                defaultValue={field.value}
                                                                field={field}
                                                                errors={errors[`question${index}`]}
                                                                className={'required'}
                                                                autoSize={{ minRows: 18, maxRows: 18 }}
                                                            />
                                                        )}
                                                    />
                                                </div>
                                            </Col>
                                        )
                                    })
                                }

                            </Row>
                            }

                            { data?.type === 'devotional' &&
                            <Row>
                                {
                                    data?.content.map((item,index)=>{
                                        return(
                                            <Col md={12} key={index}>
                                                <div className={'dfields'}>
                                                    <Controller
                                                        name={`question${index}`}
                                                        defaultValue={item.text}
                                                        control={control}
                                                        rules={{required:Required, maxLength: maxLength(10000) , validate:checkEmptySpaces}}
                                                        render={({field: {name, ...field}}) => (
                                                            <DescriptionField
                                                                label={'Devotional Entry'}
                                                                placeholder={'Write your text here'}
                                                                type={'text'}
                                                                defaultValue={field.value}
                                                                field={field}
                                                                errors={errors[`question${index}`]}
                                                                className={'required'}
                                                                autoSize={{ minRows: 18, maxRows: 18 }}
                                                            />
                                                        )}
                                                    />
                                                </div>
                                            </Col>
                                        )
                                    })
                                }
                            </Row>
                            }

                            <Row>
                                <Col md={12}>
                                    <div className={'d-flex flex-column'}>
                                        <ThemeButton
                                            type={'Submit'}
                                            text={'Save'}
                                            className={'btn-light-lg mt-3'}
                                            loader={loader}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                    <Col md={4}>
                        <div className={'icon-box'}>
                            <div className={'icon'}>
                                <GDateIcon/>
                            </div>
                            <div className={'content'}>
                                <h5>Date</h5>
                                <p>{dayjs(data?.createdAt).format('DD-MM-YYYY')}</p>
                            </div>
                        </div>
                        <div className={'icon-box'}>
                            <div className={'icon'}>
                                <GStarIcon/>
                            </div>
                            <div className={'content'}>
                                <h5>Type</h5>
                                <p>{data.type}</p>
                            </div>
                        </div>
                    </Col>
                </Row>
            }
        </div>
    )
}